import { useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { VENDOR_GROUPS, getVisibility, labelFor, listVendors } from "@hub";
import { useHubVisitor, withVisitor } from "../hubContext";

export default function VendorDirectory({ audience }) {
  const visitor = useHubVisitor();
  const [params] = useSearchParams();
  const [query, setQuery] = useState("");
  const [group, setGroup] = useState(params.get("group") || "");
  const visibility = getVisibility();
  const groups = VENDOR_GROUPS[audience] || [];
  const title = audience === "pro" ? "Real estate pros" : "Client support vendors";

  const vendors = useMemo(() => {
    const hay = query.trim().toLowerCase();
    return listVendors()
      .filter((item) => item.audience === audience)
      .filter((item) => !group || item.group === group)
      .filter((item) => {
        if (!hay) return true;
        return `${item.name} ${item.summary} ${item.region} ${item.group}`.toLowerCase().includes(hay);
      });
  }, [audience, group, query]);

  if (visibility.vendors === false) {
    return (
      <article>
        <h1>{title}</h1>
        <p className="lead">This directory is hidden for now.</p>
      </article>
    );
  }

  return (
    <article>
      <p className="muted">
        <Link to={withVisitor("/vendors", visitor)}>Vendor hub</Link>
        {" · "}
        <Link to={withVisitor(audience === "pro" ? "/vendors/client" : "/vendors/pro", visitor)}>
          {audience === "pro" ? "Client directory" : "Pro directory"}
        </Link>
      </p>
      <h1>{title}</h1>
      <p className="lead">
        {audience === "pro"
          ? "Support for listings and the office. Placeholders until your brokerage adds its own names."
          : "Support for buyers and sellers around moving day. Education, not a bid board."}
      </p>
      <div className="hub-filters">
        <label>
          Search
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Name or region" />
        </label>
        <label>
          Category
          <select value={group} onChange={(event) => setGroup(event.target.value)}>
            <option value="">All categories</option>
            {groups.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </select>
        </label>
      </div>
      <p className="chip-row" aria-label="Category navigation">
        <button type="button" className={!group ? "chip is-active" : "chip"} onClick={() => setGroup("")}>
          All
        </button>
        {groups.map((item) => (
          <button
            key={item.id}
            type="button"
            className={group === item.id ? "chip is-active" : "chip"}
            onClick={() => setGroup(item.id)}
          >
            {item.label}
          </button>
        ))}
      </p>
      <div className="card-grid">
        {vendors.map((item) => (
          <article key={item.id} className="card">
            <p className="muted">
              {labelFor(groups, item.group)} · {item.region || "San Diego County"}
            </p>
            <h2>{item.name}</h2>
            <p>{item.summary}</p>
            <p>
              <Link to={withVisitor(`/vendors/${item.id}`, visitor)}>Vendor detail</Link>
            </p>
          </article>
        ))}
      </div>
      {!vendors.length ? (
        <p className="placeholder-note">No vendors in this filter. Add names from REChecklist Admin Controls.</p>
      ) : null}
    </article>
  );
}
